export default __webpack_public_path__ + "static/media/back-arrow.50866f19.svg";